<template>
    <div class="get-coupon-list-container">
        <detail-coupon
            :show="show"
            :can-receive-coupon-list="canReceiveCouponList"
            loadText="loading"
            :useNewVersion="useNewVersion"
            @close="closeCouponList"
            @onreceive="onReceive"
            @gotouse="gotoUse"
        />
    </div>
</template>

<script>
import DetailCoupon from 'root/blackcard/components/detailCoupon/index.vue';
import { receiveStatus, emptyStatus } from 'root/common/components/coupon/mock/index';

export default {
    components: { DetailCoupon },
    props: {
        show: Boolean,
        canReceiveCouponList: Array,
        useNewVersion: {
            default: false,
            type: Boolean,
        },
    },
    model: {
        prop: 'show',
        event: 'show-change',
    },
    methods: {
        // 展示优惠券弹窗
        openCouponList() {
            this.$emit('show-change', true);
        },
        // 关闭优惠券弹窗
        closeCouponList() {
            this.$emit('show-change', false);
        },
        // 使用优惠券
        gotoUse(item, index) {
            this.$emit('show-change', false);
            this.$emit('gotouse', item, index);
        },
        // 领取优惠券
        onReceive(res, item, index) {
            const coupon = this.canReceiveCouponList[index];
            // 已抢光且用户未领取 改成已抢光样式
            if (res.status != null && res.status == 2) {
                coupon.status = emptyStatus;
                return;
            }

            if (res.flag || res.used) {
                // 领取成功
                // 修改券状态 不使用缓存
                // coupon.status = res.continueReceive ? continueReceiveStatus : receiveStatus;
                coupon.status = receiveStatus;
                if (res.couponEndTime) coupon.couponEndTime = res.couponEndTime;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.get-coupon-list-container {
}
</style>
